export default "__VITE_ASSET__CFBfijW6__"